import memoize from 'lodash/memoize';

/* eslint-disable no-bitwise */
function hashFnv32a(str: string) {
    let hval = 0x811c9dc5;

    for (let i = 0, l = str.length; i < l; i++) {
        hval ^= str.charCodeAt(i);
        hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
    }

    return hval >>> 0;
}

export function strToHex(str: string) {
    const hash = hashFnv32a(str);

    const r = ~~(
        Number(
            '0.' +
                Math.sin(hash + 1)
                    .toString()
                    .slice(6),
        ) * 256
    );
    const g = ~~(
        Number(
            '0.' +
                Math.sin(hash + 2)
                    .toString()
                    .slice(6),
        ) * 256
    );
    const b = ~~(
        Number(
            '0.' +
                Math.sin(hash + 3)
                    .toString()
                    .slice(6),
        ) * 256
    );

    let hex = '#';

    hex += ('00' + r.toString(16)).substr(-2, 2).toUpperCase();
    hex += ('00' + g.toString(16)).substr(-2, 2).toUpperCase();
    hex += ('00' + b.toString(16)).substr(-2, 2).toUpperCase();

    return hex;
}
/* eslint-enable no-bitwise */

export function invertHex(hex: string) {
    const WHITE_COLOR = '#ffffff';
    const BLACK_COLOR = '#000000';

    // eslint-disable no-param-reassign
    let normalizedHex = hex.startsWith('#') ? hex.slice(1) : hex;

    // Convert 3-digit hex to 6-digits.
    if (normalizedHex.length === 3) {
        normalizedHex = Array.from(
            new Array(6),
            (_item, index) => normalizedHex[Math.floor(index / 2)],
        ).join('');
    }
    // eslint-enable no-param-reassign

    const r = parseInt(normalizedHex.slice(0, 2), 16);
    const g = parseInt(normalizedHex.slice(2, 4), 16);
    const b = parseInt(normalizedHex.slice(4, 6), 16);

    // http://stackoverflow.com/a/3943023/112731
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? BLACK_COLOR : WHITE_COLOR;
}

export const strToHexMemoized = memoize(strToHex);
